import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";

export const withdrawApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getWithdrawList: builder.query<
      IApiResponse<any>,
      { search?: object; page?: number; deleted?: boolean }
    >({
      query: ({ search, page, deleted }) => ({
        url: "withdraw/list",
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
          ...(page && { page }),
          ...(deleted && { deleted }),
        },
      }),
      providesTags: ["Withdraw"],
    }),

    getWithdraw: builder.query<any, number>({
      query: (id) => ({
        url: `withdraw/show/${id}`,
        method: "GET",
      }),
      transformResponse(baseQueryReturnValue: IApiResponse) {
        return baseQueryReturnValue?.response?.data;
      },
      providesTags: ["Withdraw"],
    }),

    storeWithdraw: builder.mutation<any, any>({
      query: (data) => ({
        url: "Withdraw",
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    updateWithdraw: builder.mutation<
      IApiResponse<any>,
      { id: number; value: object }
    >({
      query: ({ id, value }) => ({
        url: `withdraw/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    deleteWithdraw: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `withdraw/${id}`,
        method: "POST",
        body: { _method: "DELETE" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    restoreWithdraw: builder.mutation<IApiResponse<any>, number>({
      query: (id) => ({
        url: `withdraw/restore/${id}`,
        method: "POST",
        body: { _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    WithdrawChangeAmount: builder.mutation<
      IApiResponse<any>,
      {
        id: number;
        value: {
          name: string;
          balance: number;
          type: "increment" | "decrement";
        };
      }
    >({
      query: ({ id, value }) => ({
        url: `withdraw/${id}`,
        method: "POST",
        body: { ...value, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    acceptWithdrawStatus: builder.mutation<
      IApiResponse<any>,
      { id: number; data: any }
    >({
      query: ({ id, data }) => ({
        url: `withdraw/change-status-to-accepted/${id}`,
        method: "POST",
        body: { ...data, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    rejectWithdrawStatus: builder.mutation<
      IApiResponse<any>,
      { id: number; data: any }
    >({
      query: ({ id, data }) => ({
        url: `withdraw/change-status-to-rejected/${id}`,
        method: "POST",
        body: { ...data, _method: "PUT" },
      }),
      invalidatesTags: (result) => (result ? [{ type: "Withdraw" }] : []),
    }),

    getWithdrawReport: builder.query<IApiResponse<any>, { search?: object }>({
      query: ({ search }) => ({
        url: "report/withdraw",
        method: "GET",
        params: {
          ...(search && { search: JSON.stringify({ ...search }) }),
        },
      }),
    }),
  }),
});

export const {
  useGetWithdrawListQuery,
  useGetWithdrawQuery,
  useStoreWithdrawMutation,
  useUpdateWithdrawMutation,
  useDeleteWithdrawMutation,
  useRestoreWithdrawMutation,
  useWithdrawChangeAmountMutation,
  useAcceptWithdrawStatusMutation,
  useRejectWithdrawStatusMutation,
  useGetWithdrawReportQuery,
} = withdrawApi;

export default withdrawApi;
